import React from "react"

import { Alert } from "@material-ui/lab"
import Pagination from "@material-ui/lab/Pagination"
import { CardActions, CircularProgress, Grid } from "@material-ui/core"

import Layout from "../../components/layout"
import BlogCard from "../../components/BlogCard"
import ArticleListItem from "../../components/ArticleListItem"

import { iskibrisstrapi } from "../../api/strapi/strapi"

const Blog = ({  }) => {

  const [cartArticles, setCartArticles] = React.useState(null)

  const [rowsPerPage] = React.useState(12)
  const [pagiPage, setPage] = React.useState(1)
  const [lastPage, setLastPage] = React.useState(undefined)
  const [fetchError, setFetchError] = React.useState(false)

  React.useEffect(() => {
    iskibrisstrapi.getArticles(pagiPage, rowsPerPage)
      .then((response) => {
        setCartArticles(response.data?.data)
        setLastPage( Math.ceil((response.data?.meta?.pagination?.total ?? 0) / rowsPerPage) )
      })
      .catch((err) => {
        console.log("Error fetching articles: ", err);
        setFetchError(true)
      })
  }, [pagiPage, rowsPerPage])

  return (
    <Layout>
      <div className="pt-4 mt-4">
        <div className="wrapper">
          <h1 className="headline--centered">Blog</h1>
        </div>
      </div>
      {
        cartArticles
        ?
        (
          <Grid container className="content--with-banner-container">
          <Grid item xs={12} sm={12} md={4} lg={4}>
            {cartArticles.map((article, i) => (
              <ArticleListItem article={article} key={`article__left__${article?.attributes?.slug}`} />
            ))}
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            {cartArticles
              // .slice((pagiPage - 1) * rowsPerPage, (pagiPage - 1) * rowsPerPage + rowsPerPage)
              .map((article, i) => {
                return (
                  <div key={article?.attributes?.slug}>
                    <BlogCard article={article} key={`article__left__${article?.attributes?.slug}`} />
                    <p></p>
                  </div>
                )
              })}
            <CardActions
              style={{
                justifyContent: "center",
                marginTop: "15px"
              }}
            >
              <Pagination
                count={lastPage}
                color="primary"
                page={pagiPage}
                onChange={(event, value) => {
                  setPage(value)
                }}
              />
            </CardActions>
          </Grid>
          </Grid>
        )
        :
        (
          <div style={{height: "100%"}}>
          {
            fetchError
            ?
            (
              <div style={{display: "flex", justifyContent: "center", alignItems: "flex-start"}}><Alert severity="error" style={{width: "80%"}}>Blog gönderileri getirilirken hata oluştu. Ağ bağlantınızı kontrol edin ve tekrar deneyin.</Alert></div>
            )
            :
            (
              <div style={{display: "flex", justifyContent: "center", alignItems: "flex-start"}}><CircularProgress /></div>
            )
          }
          </div>
        )
      }
    </Layout>
  )
}

export default Blog
